module.exports = __webpack_public_path__ + "static/media/logoSt.47507912.png";